import { v4 as uuid } from 'uuid';
import dynamicCustomInput from '@/components/common/input/mixins/dynamicCustomInput';

export default {
  mixins: [dynamicCustomInput({ autoEmit: true, propTypes: [String, Number] })],
  mounted() {
    if (this.shouldAutofocus) {
      this.$refs.input.focus();
    }
  },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    mask: {
      type: [String, Array, Function, RegExp],
      default: null,
    },
    maxlength: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'text',
    },
    useBottomBorder: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
    shouldAutofocus: {
      type: Boolean,
      default: false,
    },
    isValidatorBoxVisible: {
      type: Boolean,
      default: true,
    },
    isHighlighted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    remainingChars() {
      const currentChars = this.innerValue?.length || 0;

      return `${currentChars}/${this.maxlength}`;
    },
    maxLengthOrFalse() {
      return this.maxlength > 0
        ? this.maxlength
        : false;
    },
  },
  data() {
    return {
      htmlId: this.id || uuid(),
    };
  },
};
